import request from '@/utils/request'
const apiPath = '/course/courseExam/tee'

/**
 * 课后考试（REQ-2026-403009）
 * 两块：课程编辑页的「考试配置」弹窗、考试记录页的「课后考试」页签
 *
 * ⚠️ 旧「类型考试」「课程考试」记录仍走 api/course/courseExamRecords，两边不要混
 */
const courseExamApi = {
  // 某课时的考试配置；未配置返回 data=null
  fetchConfig(videoId) {
    return request.get(`${apiPath}/config`, { params: { videoId } })
  },
  // 某课程下所有课时的考试配置
  fetchConfigList(subjectId) {
    return request.get(`${apiPath}/configList`, { params: { subjectId } })
  },
  saveConfig(data) {
    return request.post(`${apiPath}/saveConfig`, data)
  },
  // 课后考试记录分页
  fetchPaperList(query) {
    return request.get(`${apiPath}/paperList`, { params: query })
  },
  // 答题详情（管理端不受解析策略限制，一律给正确答案）
  fetchPaperDetail(paperId) {
    return request.get(`${apiPath}/paperDetail`, { params: { paperId } })
  },
  // 导出：异步任务，到「导出记录」页下载，code=EEForCourseExamPaper
  exportPaper(query) {
    return request.get(`${apiPath}/exportPaper`, { params: query })
  },
  // 作废答卷并返还次数，原因必填
  voidPaper(data) {
    return request.post(`${apiPath}/voidPaper`, data)
  },
  fetchAudit(paperId) {
    return request.get(`${apiPath}/audit`, { params: { paperId } })
  }
}
export default courseExamApi
